import { Button, Dropdown } from "antd";
import {
  DashboardOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { textMap } from "../i18n";
import { useUiState } from "../state";

export function GlobalUserMenu() {
  const navigate = useNavigate();
  const { lang, authed, logout } = useUiState();
  const t = textMap[lang];

  const items = useMemo(
    () => [
      {
        key: "overview",
        label: t.userMenuConsoleOverview,
        icon: <DashboardOutlined />,
      },
      {
        key: authed ? "logout" : "login",
        label: authed ? t.logoutEntry : t.loginEntry,
        icon: authed ? <LogoutOutlined /> : <UserOutlined />,
      },
    ],
    [authed, t.loginEntry, t.logoutEntry, t.userMenuConsoleOverview],
  );

  return (
    <Dropdown
      menu={{
        items,
        onClick: ({ key }) => {
          if (key === "overview") {
            navigate("/app/dashboard");
            return;
          }
          if (key === "logout") {
            logout();
            return;
          }
          if (key === "login") {
            navigate("/login");
          }
        },
      }}
      trigger={["hover"]}
      placement="bottomRight"
    >
      <Button
        type="text"
        className="icon-btn-pill icon-btn-pill-circle global-user-menu-trigger"
        icon={<UserOutlined />}
        aria-label={lang === "zh" ? "账户菜单" : "Account menu"}
      />
    </Dropdown>
  );
}
